import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from 'src/redux-file/hooks';
import { useGhgOrganization } from 'src/common/hooks';
import { OrganizationTag, hasTag } from 'src/utils/tags';
import { useSupplierSurveyOwn } from 'src/Ghg/hooks';

/**
 * Blocks Scope 1/2 pages for Raben suppliers until they explicitly choose
 * "use platform" (wants_to_use_platform=true) for the selected reporting year.
 */
export default function Scope12UnlockGuard() {
  const org = useGhgOrganization();
  const location = useLocation();
  const { selectedDate } = useAppSelector((state) => state.questionnaire);
  const selectedYear = String(selectedDate.getFullYear());
  const survey = useSupplierSurveyOwn(org.id, selectedYear);

  const shouldEnforce = hasTag(org, OrganizationTag.Raben);

  if (!shouldEnforce) return <Outlet />;

  // While loading the decision state, block access (no flash of content).
  if (survey.isLoading) {
    return null;
  }

  const unlocked = survey.data?.answer?.wants_to_use_platform === true;

  if (!unlocked) {
    return (
      <Navigate
        to="/ghg/dashboard"
        replace
        state={{ from: location.pathname, scope12_locked: true }}
      />
    );
  }

  return <Outlet />;
}
